module.exports = __webpack_public_path__ + "img/lock.d6d3bb09.jpg";